<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="cancel" @click="$emit('return_modal_cancel_form')" v-if="modal == true" />

        <action-button
          type="add_to_participant"
          :text="$t('global.merge')"
          @click="callback_enrverify_show(enrolment.id, false)"
          v-if="showMergeBtn && !modal"
        />
        <action-button type="back" @click="$router.go(-1)" v-if="modal != true" />
        <action-button type="save" @click="presave" v-if="$can('enrolment-edit')" />
        <action-button type="delete" @click="del(enrolment.id)" v-if="$can('enrolment-delete') && !modal" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex lg8 md8 sm12 xs12>
            <v-card>
              <v-card-text class="pa-4">
                <v-layout row wrap>
                  <v-flex xs12 v-if="enrolment.status == 6">
                    <v-combobox
                      name="certificate.participant_id"
                      v-model="selectedParticipant"
                      :items="participants"
                      item-text="full_name"
                      item-value="id"
                      :label="$t('courses.select_students')"
                      autocomplete="new-password"
                      :search-input.sync="searchStudent"
                      @change="participantChange"
                    ></v-combobox>
                  </v-flex>
                  <v-flex lg4 md4 sm6 xs12>
                    <v-text-field
                      name="p_first_name"
                      v-model="enrolment.first_name"
                      :label="$t('enrolments.p_first_name')"
                      class="required-field"
                      v-validate="'required|max:50'"
                      :error-messages="errors.collect('p_first_name')"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg4 md4 sm6 xs12>
                    <v-text-field
                      name="p_last_name"
                      v-model="enrolment.last_name"
                      :label="$t('enrolments.p_last_name')"
                      class="required-field"
                      v-validate="'required|max:50'"
                      :error-messages="errors.collect('p_last_name')"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg4 md4 sm6 xs12>
                    <v-text-field
                      name="p_email"
                      v-model="enrolment.email"
                      :label="$t('enrolments.p_email')"
                      class="required-field"
                      v-validate="'required|email|max:255'"
                      :error-messages="errors.collect('p_email')"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg4 md4 sm6 xs12>
                    <vue-tel-input-vuetify
                      v-validate="'required|max:50'"
                      :label="$t('enrolments.p_mobile')"
                      v-model="enrolment.mobile"
                      @input="
                        (formattedNumber, { number, valid, country }) => {
                          enrolment.mobile = number.significant || formattedNumber
                          enrolment.mobile_code = country.dialCode || null
                        }
                      "
                      placeholder=""
                      name="p_mobile"
                      :error-messages="errors.collect('p_mobile')"
                      defaultCountry="NO"
                    ></vue-tel-input-vuetify>
                  </v-flex>
                  <v-flex lg4 md4 sm6 xs12>
                    <v-dialog ref="dialog" v-model="dob_date_menu" persistent width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          name="p_date_of_birth"
                          v-model="computedDateofBirth"
                          :label="$t('fe.enrolment.p_date_of_birth')"
                          class="required-field"
                          v-validate="'required|validDate'"
                          :error-messages="errors.collect('p_date_of_birth')"
                          append-icon="event"
                          @click:append="dob_date_menu = true"
                          :hint="'Format: ' + DATE_FORMAT"
                          autocomplete="new-password"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        color="primary"
                        v-model="enrolment.date_of_birth"
                        first-day-of-week="1"
                        :locale="this.$locale_bcp47($getSetting('locale'))"
                        :max="moment().subtract(1, 'days').format(MYSQL_DATE_FORMAT)"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" class="darken-2" @click="dob_date_menu = false">{{ $t("global.ok") }}</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-flex>
                  <v-flex lg4 md4 sm6 xs12>
                    <v-text-field
                      name="enrolment.created_at"
                      :value="enrolment.created_at ? moment.utc(enrolment.created_at).format(DATE_FORMAT + ' ' + TIME_FORMAT) : ''"
                      :label="$t('enrolments.enrolled')"
                      readonly
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>

                  <!-- START : ORGANISATION -->
                  <v-flex xs12 class="ma-0 pa-0"></v-flex>
                  <v-flex lg5 md6 sm9 xs12>
                    <v-combobox
                      name="o_name"
                      v-model="organisation.name"
                      :items="organisations"
                      item-text="text"
                      item-value="vat"
                      :label="$t('fe.enrolment.o_name')"
                      autocomplete="new-password"
                      :error-messages="errors.collect('o_name')"
                      :search-input.sync="orgNameSearch"
                      @change="updateOrgVat"
                      clearable
                    >
                      <template v-slot:append>
                        <span class="d-none">&nbsp;</span>
                      </template>
                      <template v-slot:append-item>
                        <span class="d-none">&nbsp;</span>
                      </template>
                      <template v-slot:no-data>
                        {{ $t("organisations.org_does_not_exist") }}
                      </template>
                      <template v-slot:item="{ index, item }"> {{ item.text }} ({{ item.vat }}) </template>
                    </v-combobox>
                  </v-flex>
                  <v-flex lg3 md3 sm3 xs12>
                    <v-text-field
                      name="o_vat"
                      v-model="organisation.vat"
                      v-validate="'max:9'"
                      :label="$t('fe.enrolment.o_vat')"
                      :error-messages="errors.collect('o_vat')"
                      @keypress="$keyDown_IntOnly($event)"
                      :hint="$t('global.helptext_vat')"
                      persistent-hint
                      :append-outer-icon="'sync'"
                      @click:append-outer="searchOrgByVat(organisation.vat)"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg4 md4 sm6 xs12>
                    <v-text-field
                      name="o_first_name"
                      v-model="organisation.first_name"
                      v-validate="'max:50'"
                      :label="$t('fe.enrolment.o_first_name')"
                      :error-messages="errors.collect('o_first_name')"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg4 md4 sm6 xs12>
                    <v-text-field
                      name="o_last_name"
                      v-model="organisation.last_name"
                      v-validate="'max:50'"
                      :label="$t('fe.enrolment.o_last_name')"
                      :error-messages="errors.collect('o_last_name')"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg4 md4 sm6 xs12>
                    <v-text-field
                      name="o_email"
                      v-model="organisation.email"
                      v-validate="'email|max:255'"
                      :label="$t('fe.enrolment.o_email')"
                      :error-messages="errors.collect('o_email')"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg4 md4 sm6 xs12>
                    <v-text-field
                      name="enrolment.reference"
                      v-model="enrolment.reference"
                      :label="$t('enrolments.o_reference')"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="ma-0 pa-0"></v-flex>
                  <!-- END : ORGANISATION -->

                  <v-flex xs12>
                    <v-textarea
                      dense
                      name="enrolments.comment"
                      v-model="enrolment.comments"
                      :label="$t('enrolments.comment')"
                      rows="1"
                      auto-grow
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs12 class="enable-internal-note">
                    <v-textarea
                      dense
                      name="enrolments.internal_notes"
                      v-model="enrolment.internal_notes"
                      :label="$t('enrolments.internal_notes')"
                      rows="1"
                      auto-grow
                    ></v-textarea>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>

            <v-card class="mt-4">
              <v-app-bar dense text color="secondary">
                <v-toolbar-title class="subheading">{{ $t("enrolments.address_title") }}</v-toolbar-title>
              </v-app-bar>
              <v-card-text class="pa-4">
                <v-layout row wrap>
                  <v-flex lg3 md4 sm6 xs12>
                    <v-text-field
                      name="enrolment.street"
                      v-model="enrolment.street"
                      :label="$t('enrolments.p_address_street')"
                      v-validate="'max:50'"
                      :error-messages="errors.collect('p_address_street')"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg1 md4 sm6 xs12>
                    <v-text-field
                      name="enrolment.zip"
                      v-model="enrolment.zip"
                      :label="$t('enrolments.p_address_zip')"
                      v-validate="'max:6'"
                      :error-messages="errors.collect('p_address_zip')"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg2 md4 sm6 xs12>
                    <v-text-field
                      name="enrolment.city"
                      v-model="enrolment.city"
                      v-validate="'max:50'"
                      :label="$t('enrolments.p_address_city')"
                      :error-messages="errors.collect('p_address_city')"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg3 md4 sm6 xs12>
                    <v-autocomplete
                      name="p_address_country"
                      v-model="enrolment.country"
                      :items="this.$dd_countries()"
                      item-text="text"
                      item-value="key"
                      :label="$t('fe.enrolment.p_address_country')"
                      autocomplete="new-password"
                      :error-messages="errors.collect('p_address_country')"
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>

            <p class="text-left mt-2 mb-0" v-if="enrolment.updated_by && enrolment.updated_by_name">
              {{ $t("global.last_updated_by") + enrolment.updated_by_name }}
              {{ moment.utc(enrolment.updated_at).format(DATE_FORMAT + " " + TIME_FORMAT) }}
            </p>
          </v-flex>
          <v-flex lg4 md4 sm12 xs12>
            <v-card>
              <v-card-text class="pa-4">
                <p class="font-weight-black sidebar-price-title">{{ $t("fe.enrolment.include") }}</p>
                <div v-for="(mt, index) in moduletemplates_included" :key="mt.id">
                  <p class="font-weight-black mb-0">{{ mt.name }}</p>

                  <div v-if="mt.moduleoptions.length > 0">
                    <v-radio-group
                      dense
                      v-model="selectedIncAdditionals[mt.id].selected_option"
                      @change="moduleoptionChangeInc"
                      class="mt-0 radio-full-width"
                      v-validate="'required'"
                      :name="'mo.' + mt.id"
                    >
                      <v-simple-table dense>
                        <tr v-if="!mt.mandatory">
                          <td scope="row">
                            <v-radio dense :label="$t('global.none_select')" value="none"></v-radio>
                          </td>
                          <td scope="row" class="text-end" width="20%"></td>
                        </tr>
                        <tr v-for="mo in mt.moduleoptions" :key="mo.id">
                          <td scope="row">
                            <v-radio
                              dense
                              :label="mo.name + (mo.hours > 0 ? ' (' + mo.hours + ' ' + $t('moduleoptions.hours') + ')' : '')"
                              :value="mo.id"
                            ></v-radio>
                            <span class="pl-3 mb-3 d-block">{{ mo.comment }}</span>
                          </td>
                          <td scope="row" class="text-end va-text-top price" width="20%">
                            <span v-if="mo.price">{{ mo.price + " " + CURRENCY }}</span>
                          </td>
                        </tr>
                      </v-simple-table>
                    </v-radio-group>
                    <div class="v-messages theme--light error--text">
                      <div class="v-messages__wrapper">
                        <div class="v-messages__message">{{ errors.first("mo." + mt.id) }}</div>
                      </div>
                    </div>

                    <div v-for="mo in mt.moduleoptions" :key="mo.id">
                      <div v-if="moduleoptioncoursetypesinc[mo.id].length > 0 && selectedIncAdditionals[mt.id].selected_option == mo.id">
                        <v-divider class="mb-3"></v-divider>

                        <p class="mb-0">
                          {{ mt.name }} -
                          <span class="font-italic">{{ $t("fe.enrolment.select_course_types") }}</span>
                        </p>
                        <v-simple-table dense>
                          <tr v-for="moct in moduleoptioncoursetypesinc[mo.id]" :key="moct.id">
                            <td scope="row">
                              <v-checkbox
                                :name="'moct.' + mt.id"
                                dense
                                :label="moct.name"
                                v-model="selectedIncAdditionals[mt.id].selected_coursetypes"
                                :value="moct.id"
                                class="chk-moduleoption mt-0"
                                @change="moduleoptionChangeInc"
                                v-validate="'required'"
                              >
                              </v-checkbox>
                              <span class="pl-3 mb-3 d-block">{{ moct.comment }}</span>
                            </td>
                            <td scope="row" class="text-end va-text-top price" width="20%">
                              <span v-if="moct.price">{{ moct.price + " " + CURRENCY }}</span>
                            </td>
                          </tr>
                          <div class="v-messages theme--light error--text">
                            <div class="v-messages__wrapper">
                              <div class="v-messages__message">{{ errors.first("moct." + mt.id) }}</div>
                            </div>
                          </div>
                        </v-simple-table>
                      </div>
                    </div>
                    <v-divider class="mb-2" v-if="index < moduletemplates_included.length - 1"></v-divider>
                  </div>
                </div>

                <v-divider class="mb-3"></v-divider>

                <p class="font-weight-black sidebar-price-title">{{ $t("fe.enrolment.additionals") }}</p>

                <div v-for="(mt, index) in moduletemplates_not_included" :key="mt.id">
                  <p class="font-weight-black mb-0">{{ mt.name }}</p>

                  <div v-if="mt.moduleoptions.length > 0">
                    <v-radio-group
                      dense
                      v-model="selectedAdditionals[mt.id].selected_option"
                      @change="moduleoptionChange"
                      class="mt-0 radio-full-width"
                      v-validate="'required'"
                      :name="'mo.' + mt.id"
                    >
                      <v-simple-table dense>
                        <tr v-if="!mt.mandatory">
                          <td scope="row">
                            <v-radio dense :label="$t('global.none_select')" value="none"></v-radio>
                          </td>
                          <td scope="row" class="text-end" width="20%"></td>
                        </tr>
                        <tr v-for="mo in mt.moduleoptions" :key="mo.id">
                          <td scope="row">
                            <v-radio
                              dense
                              :label="mo.name + (mo.hours > 0 ? ' (' + mo.hours + ' ' + $t('moduleoptions.hours') + ')' : '')"
                              :value="mo.id"
                            ></v-radio>
                            <span class="pl-3 mb-3 d-block">{{ mo.comment }}</span>
                          </td>
                          <td scope="row" class="text-end va-text-top price" width="20%">
                            <span v-if="mo.price">{{ mo.price + " " + CURRENCY }}</span>
                          </td>
                        </tr>
                      </v-simple-table>
                    </v-radio-group>
                    <div class="v-messages theme--light error--text">
                      <div class="v-messages__wrapper">
                        <div class="v-messages__message">{{ errors.first("mo." + mt.id) }}</div>
                      </div>
                    </div>
                  </div>

                  <div v-for="mo in mt.moduleoptions" :key="mo.id">
                    <div v-if="moduleoptioncoursetypes[mo.id].length > 0 && selectedAdditionals[mt.id].selected_option == mo.id">
                      <v-divider class="mb-3"></v-divider>

                      <p class="mb-0">
                        {{ mt.name }} -
                        <span class="font-italic">{{ $t("fe.enrolment.select_course_types") }}</span>
                      </p>
                      <v-simple-table dense class="mt-3">
                        <tr v-for="moct in moduleoptioncoursetypes[mo.id]" :key="moct.id">
                          <td scope="row">
                            <v-checkbox
                              :name="'moct.' + mt.id"
                              dense
                              :label="moct.name"
                              v-model="selectedAdditionals[mt.id].selected_coursetypes"
                              :value="moct.id"
                              class="chk-moduleoption mt-0"
                              @change="moduleoptionChange"
                              v-validate="'required'"
                            >
                            </v-checkbox>
                            <span class="pl-3 mb-3 d-block">{{ moct.comment }}</span>
                          </td>
                          <td scope="row" class="text-end va-text-top price" width="20%">
                            <span v-if="moct.price">{{ moct.price + " " + CURRENCY }}</span>
                          </td>
                        </tr>
                        <div class="v-messages theme--light error--text">
                          <div class="v-messages__wrapper">
                            <div class="v-messages__message">{{ errors.first("moct." + mt.id) }}</div>
                          </div>
                        </div>
                      </v-simple-table>
                    </div>
                  </div>
                  <v-divider class="mb-3" v-if="index < moduletemplates_not_included.length - 1"></v-divider>
                </div>

                <v-divider class="mb-3"></v-divider>

                <v-simple-table dense class="mt-3 mb-4">
                  <tr>
                    <td scope="row">
                      <p class="font-weight-black price">{{ $t("fe.enrolment.price") }}</p>
                    </td>
                    <td scope="row" class="text-end price" width="20%">
                      <span>{{ price + " " + CURRENCY }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td scope="row">
                      <p class="font-weight-black price">{{ $t("fe.enrolment.price_additional") }}</p>
                    </td>
                    <td scope="row" class="text-end price" width="20%">
                      <span>{{ price_additional + " " + CURRENCY }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td scope="row">
                      <p class="font-weight-black price">{{ $t("fe.enrolment.price_total") }}</p>
                    </td>
                    <td scope="row" class="text-end price" width="20%">
                      <span>{{ price_total + " " + CURRENCY }}</span>
                    </td>
                  </tr>
                </v-simple-table>

                <v-layout row wrap>
                  <v-flex xs12 sm6 class="text-left" v-if="enrolment.created_at">{{
                    $t("attendees.enrolled_date") + ":" + moment.utc(enrolment.created_at).format(DATE_FORMAT + " " + TIME_FORMAT)
                  }}</v-flex>
                  <v-flex xs12 sm6 class="text-right" v-if="enrolment.payment && enrolment.payment.payment_method">
                    {{ $t("enrolments.payment_method") + ":" }}
                    <b>{{ enrolment.payment.payment_method.toUpperCase() || null }}</b>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>

    <enrolmentVerifyPopup
      :key="reRenderEnrVerify"
      :id="enrVerifiySelectedId"
      :validate="enrVerifiyValidate"
      @callback_enrverify_validate="callback_enrverify_validate"
      @callback_enrverify_merge="callback_enrverify_merge"
      @callback_enrverify_cancel="callback_enrverify_cancel"
      @callback_enrverify_postprocess="callback_enrverify_postprocess"
    />
  </v-container>
</template>

<script>
import enrolmentVerifyPopup from "../../enrolments/partials/EnrolmentVerifyPopup.vue"
import PhoneNumber from "awesome-phonenumber"
import VueTelInputVuetify from "@/mixins/vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue"

export default {
  name: "EnrolmentBasicEdit",

  props: ["id", "modal"],

  components: {
    enrolmentVerifyPopup,
    VueTelInputVuetify
  },

  data() {
    return {
      page_title: "",
      predata: {},
      enrolment: {},
      additionals: {},
      organisation: { id: null },
      dob_date_menu: false,

      showMergeBtn: false,
      enrVerifiySelectedId: 0,
      enrVerifiyValidate: false,
      reRenderEnrVerify: 0,

      organisations: [],
      orgNameSearch: null,

      moduletemplates: [],
      moduletemplates_included: [],
      moduletemplates_not_included: [],

      moduleoptioncoursetypes: {},
      selectedAdditionals: {},

      moduleoptioncoursetypesinc: {},
      selectedIncAdditionals: {},

      price: 0,
      price_additional: 0,
      price_total: 0,

      selectedParticipant: null,
      participants: [],
      searchStudent: null,

      dictionary: {
        attributes: {
          p_first_name: this.$t("fe.enrolment.p_first_name"),
          p_last_name: this.$t("fe.enrolment.p_last_name"),
          p_email: this.$t("fe.enrolment.p_email"),
          p_mobile: this.$t("fe.enrolment.p_mobile"),
          p_date_of_birth: this.$t("fe.enrolment.p_date_of_birth"),
          p_address_street: this.$t("fe.enrolment.p_address_street"),
          p_address_city: this.$t("fe.enrolment.p_address_city"),
          p_address_state: this.$t("fe.enrolment.p_address_state"),
          p_address_zip: this.$t("fe.enrolment.p_address_zip"),
          p_address_country: this.$t("fe.enrolment.p_address_country"),
          o_vat: this.$t("fe.enrolment.o_vat"),
          o_name: this.$t("fe.enrolment.o_name"),
          o_first_name: this.$t("fe.enrolment.o_first_name"),
          o_last_name: this.$t("fe.enrolment.o_last_name"),
          o_email: this.$t("fe.enrolment.o_email"),
          coursetype: this.$t("moduleoptioncoursetypes.coursetype_id")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.enrolment, this.predata, this.save, this.isFormValid)
    })
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    this.init()
  },

  watch: {
    orgNameSearch: {
      handler: _.debounce(function (search) {
        this.searchOrgVatByName(search)
      }, 300)
    },
    searchStudent: {
      handler: _.debounce(function (value) {
        if (!value) return

        if (value.length >= 3) {
          this.getStudents("fullname", value)
        } else {
          this.participants = []
        }
      }, 300)
    }
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    computedDateofBirth: {
      get() {
        return this.$dateFormatGetter(this.enrolment.date_of_birth)
      },
      set(val) {
        this.$set(this.enrolment, "date_of_birth", this.$dateFormatSetter(val))
      }
    }
  },

  methods: {
    init() {
      axios
        .get(this.API_URL + "enrolment/" + this.id)
        .then((res) => {
          this.enrolment = res.data.data
          this.additionals = this.enrolment.additionals
          this.page_title = this.$t("enrolments.details_title")

          // JSON stringify and parse to remove variable reactiveness
          this.loadPredata()

          // Validate if this enrolment can merge
          this.callback_enrverify_show(this.enrolment.id, true)

          if (this.enrolment.enrolment_organisation_id) {
            this.organisation = {
              id: this.enrolment.organisation.id,
              name: this.enrolment.organisation.name,
              vat: this.enrolment.organisation.vat,
              first_name: this.enrolment.organisation.req_first_name,
              last_name: this.enrolment.organisation.req_last_name,
              email: this.enrolment.organisation.req_email,
              mobile: this.enrolment.organisation.req_mobile
            }
          }

          if (this.enrolment.course_id) {
            let course_data = this.enrolment.original_course_data
            if (course_data) {
              course_data = JSON.parse(course_data)

              if (
                course_data &&
                course_data.course &&
                course_data.course.moduletemplates &&
                course_data.course.moduletemplates.length > 0
              ) {
                this.moduletemplates = course_data.course.moduletemplates
              }
            }

            this.loadCourse(this.enrolment.course_id)
          }

          if (this.enrolment.payment) {
            this.price = this.enrolment.payment.price
            this.price_additional = this.enrolment.payment.price_additional
            this.price_total = this.enrolment.payment.price_total
          }
        })
        .catch((err) => console.log(err))
    },
    loadPredata() {
      this.predata = JSON.parse(JSON.stringify(this.enrolment))
      this.predata.mobile_code = "47" // Norway country code

      if (this.predata.mobile) {
        let code = PhoneNumber(this.predata.mobile).getCountryCode()
        if (code) {
          let mobileJSON = PhoneNumber(this.predata.mobile).toJSON()
          this.predata.mobile = mobileJSON.number.significant || this.predata.mobile
          this.predata.mobile_code = code.toString()
        }
      }
    },
    preloadSelectedAdditionals() {
      let vm = this

      if (this.additionals) {
        // Get module templates and module options
        this.additionals.forEach((item, index) => {
          if (item.is_included) {
            // INCLUDED
            let mt = this.moduletemplates_included.find((i) => i.id == item.moduletemplate_id)
            if (mt) {
              vm.$set(vm.selectedIncAdditionals[mt.id], "selected_option", item.moduleoption_id || "none")
            }

            if (item.moduleoptioncoursetype_id) {
              let moct = this.moduleoptioncoursetypesinc[item.moduleoption_id].find((i) => i.id == item.moduleoptioncoursetype_id)
              if (moct) {
                vm.selectedIncAdditionals[mt.id].selected_coursetypes.push(item.moduleoptioncoursetype_id)
              }
            }
          } else {
            // ADDITIONALS
            let mt = this.moduletemplates_not_included.find((i) => i.id == item.moduletemplate_id)
            if (mt) {
              vm.$set(vm.selectedAdditionals[mt.id], "selected_option", item.moduleoption_id || "none")
            }

            if (item.moduleoptioncoursetype_id) {
              let moct = this.moduleoptioncoursetypes[item.moduleoption_id].find((i) => i.id == item.moduleoptioncoursetype_id)
              if (moct) {
                vm.selectedAdditionals[mt.id].selected_coursetypes.push(item.moduleoptioncoursetype_id)
              }
            }
          }
        })
      }
    },
    presave() {
      let vm = this

      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            if (this.organisation.vat) {
              // check if organisation exist
              axios.post(this.API_URL + "enrolment/organisation/vat-exist/" + vm.organisation.vat).then((res) => {
                let status = res.data.status
                let record = res.data.record
                let method = "POST"

                if (status == "exist") {
                  vm.organisation.id = record.id
                  method = "PUT"
                }

                axios({
                  method: method,
                  url: vm.API_URL + "enrolment/organisation",
                  data: vm.organisation
                })
                  .then((res) => {
                    let record = res.data.data

                    this.enrolment.enrolment_organisation_id = record.id || null
                    this.enrolment.requestor_id = record.requestor_id || null

                    this.save()
                  })
                  .catch((err) => {})
              })
            } else {
              this.save()
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let enrolment = JSON.parse(JSON.stringify(this.enrolment))

            if (enrolment.status == 6) {
              enrolment.status = 1

              if(this.selectedParticipant) {
                enrolment.participant_id = this.selectedParticipant.id
              }
            }

            enrolment.mobile = this.$formatPhoneNumber(enrolment.mobile, enrolment.mobile_code)
            enrolment.price = this.price
            enrolment.price_additional = this.price_additional
            enrolment.price_total = this.price_total
            enrolment.additionals = JSON.stringify(this.selectedAdditionals)
            enrolment.additionals_inc = JSON.stringify(this.selectedIncAdditionals)

            axios
              .put(this.API_URL + "enrolment", enrolment)
              .then((res) => {
                vm.enrolment = res.data.data
                vm.loadPredata()
                vm.callback_enrverify_show(vm.enrolment.id, true)

                if (vm.modal) {
                  vm.$emit("return_modal_form", {
                    module: "enrolment",
                    mode: "update",
                    data: res.data.data
                  })
                } else {
                  vm.loadPredata()
                  vm.$awn.success(vm.$t("global.update_success"))
                }
              })
              .catch((err) => console.log(err))
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },

    searchOrgByVat(search) {
      let vm = this

      if (search) {
        this.organisations = []

        axios
          .get(this.BRREG_API_URL + search)
          .then((res) => {
            let data = res.data
            let companyname = this.$formatAPICompanyName(data.navn)
            this.organisations.push({
              key: companyname,
              text: companyname,
              vat: data.organisasjonsnummer
            })
            // Automaticlly set the organisation name
            this.$set(this.organisation, "name", companyname || null)
            this.$set(this.organisation, "vat", data.organisasjonsnummer || null)
          })
          .catch(function(error) {
            vm.$awn.alert(vm.$t("organisations.vat_does_not_exist"))
            vm.$set(vm.organisation, "name", null)
            vm.$set(vm.organisation, "vat", null)
          })

        // let promise = this.$api1881SearchVAT(search)
        // promise
        //   .then((res) => {
        //     let data = res.data
        //     if (data && data.contacts) {
        //       this.organisations = data.contacts.map((item) => {
        //         return {
        //           id: item.id,
        //           key: item.name,
        //           text: item.name,
        //           vat: item.organizationNumber
        //         }
        //       })

        //       this.$set(this.organisation, "name", this.organisations.length ? this.organisations[0].text : null)
        //       this.$set(this.organisation, "vat", this.organisations.length ? this.organisations[0].vat : null)
        //     } else {
        //       vm.$awn.alert(vm.$t("organisations.vat_does_not_exist"))
        //     }
        //   })
        //   .catch(function (error) {
        //     vm.$awn.alert(vm.$t("organisations.vat_does_not_exist"))
        //   })
      }
    },
    searchOrgVatByName(search) {
      if (search) {
        this.organisations = []

        let org = this.organisations.find((i) => i.key == search)
        if (org && org.vat) {
        } else {
          axios
            .get(this.BRREG_API_URL + "?navn=" + search)
            .then((res) => {
              let data = res.data
              if (data.page.totalElements > 0) {
                this.organisations = data._embedded.enheter.slice(0, 3).map((item) => {
                  let companyname = this.$formatAPICompanyName(item.navn)
                  return {
                    key: companyname,
                    text: companyname,
                    vat: item.organisasjonsnummer,
                  }
                })
              }
            })
            .catch(function(error) {})
        }

        // let promise = this.$api1881SearchName(search)
        // promise.then((res) => {
        //   let data = res.data
        //   if (data && data.contacts) {
        //     this.organisations = data.contacts.map((item) => {
        //       return {
        //         id: item.id,
        //         key: item.name,
        //         text: item.name,
        //         vat: item.organizationNumber
        //       }
        //     })
        //   }
        // })
      }
    },
    updateOrgVat() {
      if (this.organisation.name && typeof this.organisation.name === "object") {
        let org = this.organisations.find((i) => i.key == this.organisation.name.key)
        if (org) {
          this.$set(this.organisation, "name", org.text || null)
          this.$set(this.organisation, "vat", org.vat || null)
          return
        }
        
        // let org = this.organisations.find((i) => i.vat == this.organisation.name.vat)
        // if (org) {
        //   let promise = this.$api1881SearchID(org.id)
        //   promise
        //     .then((res) => {
        //       let data = res.data
        //       if (data && data.contacts) {
        //         data = data.contacts[0]

        //         this.$set(this.enrolment, "street", data.geography.address.street + " " + data.geography.address.houseNumber)
        //         this.$set(this.enrolment, "zip", data.geography.address.postCode)
        //         this.$set(this.enrolment, "city", data.geography.address.postArea)
        //         this.$set(this.enrolment, "state", data.geography.county)
        //       }
        //     })
        //     .catch(function (error) {
        //       console.log(error)
        //     })

        //   this.$set(this.organisation, "name", org.text)
        //   this.$set(this.organisation, "vat", org.vat)

        //   this.$set(this.enrolment, "street", null)
        //   this.$set(this.enrolment, "zip", null)
        //   this.$set(this.enrolment, "city", null)
        //   this.$set(this.enrolment, "state", null)
        //   return
        // }
      }

      this.$set(this.organisation, "name", this.organisation.name || null)
      this.$set(this.organisation, "vat", null)
    },

    loadCourse(id) {
      let vm = this

      axios.get(this.API_URL + "course/" + id).then((res) => {
        this.course = res.data.data
        //this.moduletemplates = this.course.moduletemplates;

        // Filter "Included" module templates
        this.moduletemplates_included = this.moduletemplates.filter((i) => i.is_included == 1 && !i.hide_in_enrolment)

        this.moduletemplates_included.forEach(function (mt) {
          vm.$set(vm.selectedIncAdditionals, mt.id, {})
          vm.$set(vm.selectedIncAdditionals[mt.id], "selected_coursetypes", [])

          /*if(mt.moduleoptions.length == 1) {
                            vm.$set(vm.selectedIncAdditionals[mt.id], 'selected_option', mt.mandatory ? mt.moduleoptions[0].id : "none")
                        } else {
                            vm.$set(vm.selectedIncAdditionals[mt.id], 'selected_option', mt.mandatory ? '' : "none")
                        }*/
          vm.$set(vm.selectedIncAdditionals[mt.id], "selected_option", mt.mandatory ? "" : "none")

          // Show only module option where "Enrol Select" is checked
          mt.moduleoptions = mt.moduleoptions.filter((i) => i.enrol_select == 1)

          mt.moduleoptions.forEach(function (mo) {
            if (mo.coursetypes) {
              vm.moduleoptioncoursetypesinc[mo.id] = []
              vm.moduleoptioncoursetypesinc[mo.id] = mo.coursetypes
              vm.dictionary.attributes["moct." + mt.id] = vm.$t("moduleoptioncoursetypes.coursetype_id")
            }
          })

          // Add dynamic name for checking of moduleoption coursetype
          vm.dictionary.attributes["mo." + mt.id] = vm.$t("moduleoptions.moduleoption_id")
        })

        // Filter "Not Included" module templates
        this.moduletemplates_not_included = this.moduletemplates.filter((i) => i.is_included != 1 && !i.hide_in_enrolment)

        this.moduletemplates_not_included.forEach(function (mt) {
          vm.$set(vm.selectedAdditionals, mt.id, {})
          vm.$set(vm.selectedAdditionals[mt.id], "selected_coursetypes", [])

          /*if(mt.moduleoptions.length == 1) {
                            vm.$set(vm.selectedAdditionals[mt.id], 'selected_option', mt.mandatory ? mt.moduleoptions[0].id : "none")
                        } else {
                            vm.$set(vm.selectedAdditionals[mt.id], 'selected_option', mt.mandatory ? '' : "none")
                        }*/
          vm.$set(vm.selectedAdditionals[mt.id], "selected_option", mt.mandatory ? "" : "none")

          // Show only module option where "Enrol Select" is checked
          mt.moduleoptions = mt.moduleoptions.filter((i) => i.enrol_select == 1)

          mt.moduleoptions.forEach(function (mo) {
            if (mo.coursetypes) {
              vm.moduleoptioncoursetypes[mo.id] = []
              vm.moduleoptioncoursetypes[mo.id] = mo.coursetypes
              vm.dictionary.attributes["moct." + mt.id] = vm.$t("moduleoptioncoursetypes.coursetype_id")
            }
          })

          // Add dynamic name for checking of moduleoption coursetype
          vm.dictionary.attributes["mo." + mt.id] = vm.$t("moduleoptions.moduleoption_id")
        })

        // Reinitialize validator dictionary
        vm.$validator.localize(vm.$getSetting("locale"), vm.dictionary)
        this.preloadSelectedAdditionals()
        this.recompute()
      })
    },

    recompute() {
      let vm = this

      vm.price = Boolean(_.has(vm.course, "id")) ? vm.course.price : 0
      vm.price_additional = 0
      vm.price_total = 0

      _.forEach(vm.selectedIncAdditionals, function (obj, key) {
        let mt = vm.moduletemplates_included.find((i) => i.id == key)
        let selected_option = obj.selected_option

        if (mt && selected_option != "" && selected_option != "none" && vm.moduleoptioncoursetypesinc[selected_option] !== undefined) {
          // Add the price of the selected module option
          let mo = mt.moduleoptions.find((i) => i.id == selected_option)
          if (mo) {
            vm.price_additional += mo.price
          }

          // Add the price of the selected course types
          _.forEach(obj.selected_coursetypes, function (ct) {
            let moct = vm.moduleoptioncoursetypesinc[selected_option].find((i) => i.id == ct)

            if (moct) {
              vm.price_additional += moct.price
            }
          })
        }
      })

      _.forEach(vm.selectedAdditionals, function (obj, key) {
        let mt = vm.moduletemplates_not_included.find((i) => i.id == key)
        let selected_option = obj.selected_option

        if (mt && selected_option != "" && selected_option != "none" && vm.moduleoptioncoursetypes[selected_option] !== undefined) {
          // Add the price of the selected module option
          let mo = mt.moduleoptions.find((i) => i.id == selected_option)
          if (mo) {
            vm.price_additional += mo.price
          }

          // Add the price of the selected course types
          _.forEach(obj.selected_coursetypes, function (ct) {
            let moct = vm.moduleoptioncoursetypes[selected_option].find((i) => i.id == ct)

            if (moct) {
              vm.price_additional += moct.price
            }
          })
        }
      })

      vm.price_total = vm.price + vm.price_additional
    },

    moduleoptionChange() {
      let vm = this

      _.forEach(vm.selectedAdditionals, function (obj, key) {
        let selected_option = obj.selected_option
        let selected_coursetypes = obj.selected_coursetypes

        if (selected_option != "" && selected_option != "none" && vm.moduleoptioncoursetypes[selected_option] !== undefined) {
          let moct_ids = vm.moduleoptioncoursetypes[selected_option].map((a) => a.id)
          obj.selected_coursetypes = _.intersection(moct_ids, selected_coursetypes)
        } else {
          obj.selected_coursetypes = []
        }
      })

      vm.recompute()
    },

    moduleoptionChangeInc() {
      let vm = this

      _.forEach(vm.selectedIncAdditionals, function (obj, key) {
        let selected_option = obj.selected_option
        let selected_coursetypes = obj.selected_coursetypes

        if (selected_option != "" && selected_option != "none" && vm.moduleoptioncoursetypesinc[selected_option] !== undefined) {
          let moct_ids = vm.moduleoptioncoursetypesinc[selected_option].map((a) => a.id)
          obj.selected_coursetypes = _.intersection(moct_ids, selected_coursetypes)
        } else {
          obj.selected_coursetypes = []
        }
      })

      vm.recompute()
    },

    callback_enrverify_show(id, validate) {
      this.enrVerifiySelectedId = id
      this.enrVerifiyValidate = validate
      this.reRenderEnrVerify++
    },
    callback_enrverify_validate(data) {
      if (data.status == "exist") {
        this.showMergeBtn = true
      } else {
        this.showMergeBtn = false
      }
    },
    callback_enrverify_merge(bool) {},
    callback_enrverify_cancel() {
      this.enrVerifiySelectedId = 0
      this.enrVerifiyValidate = false
      this.init()
    },
    callback_enrverify_postprocess() {
      this.convert(this.enrVerifiySelectedId)
    },
    convert(id) {
      let vm = this

      axios
        .post(this.API_URL + "participant/convert", {
          id: id
        })
        .then((res) => {
          if (typeof res.data.errors !== "undefined") {
          } else {
            if (res.data.data.id) {
              vm.$awn.success(vm.$t("enrolments.add_to_participant_success"))
            } else {
              vm.$awn.alert(vm.$t("enrolments.add_to_participant_error"))
            }

            vm.$router.push(this.BACKEND_URL + "/enrolments")
          }
        })
        .catch((err) => {
          if (err.response.status == 451) {
            vm.$awn.alert(vm.$t("enrolments.already_enrolled"))
            vm.$router.push(this.BACKEND_URL + "/enrolments")
          }
        })
    },

    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "enrolment/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/enrolments")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },

    getStudents(key, value) {
      axios
        .get(
          this.API_URL +
            `participants?resourcetype=user-ddlist&query_${key}=${value}&query_tenant_user_status=1sort_by=first_name&sort_order=asc`
        )
        .then((response) => {
          if (response.status == 200) {
            this.participants = response.data.data
          }
        })
        .catch((err) => console.log(err))
    },

    participantChange() {
      if(this.selectedParticipant) {
        this.$set(this.enrolment, "first_name", this.selectedParticipant.first_name)
        this.$set(this.enrolment, "last_name", this.selectedParticipant.last_name)
        this.$set(this.enrolment, "email", this.selectedParticipant.email)
        this.$set(this.enrolment, "mobile", this.selectedParticipant.mobile)
        this.$set(this.enrolment, "date_of_birth", this.selectedParticipant.date_of_birth)
      }
    }
  }
}
</script>

<style>
p.price,
.price span {
  font-size: 14px !important;
}
</style>
